import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { Paper, useTheme } from '@mui/material';
import { FC, useEffect, useMemo } from 'react';
import { GoPlus } from "react-icons/go";
import { useNavigate } from 'react-router-dom';
import { Flex } from '../../../Components/Flex/flex.component';
import { Button } from '../../../Components/Form/Button/button.scomponent';
import { Placeholder } from '../../../Components/Placeholder/placeholder.component';
import { Table } from '../../../Components/Table/table.component';
import { BaseContentPage } from '../../../Components/Templates/BaseContentPage/base-content-page.componen';
import { BaseScreen } from '../../../Components/Templates/BaseScreen/basescreen.component';
import { ListProductsServiceUseCase } from '../../../Usecase/ProductsService/list-products-service-usecase';
import { useServicesList } from './services-list.hook';
import { ActionButtons } from '../../../Components/Form/ActionButtons/action-buttons.component';
import { Loader } from '../../../Components/Loader';
import { Can } from '../../../Components/Can';

interface IServicesList {
  ListProductsServiceUseCase: ListProductsServiceUseCase
}
const ServicesList : FC<IServicesList> = ({ ListProductsServiceUseCase }) => {
    const theme = useTheme()
    const navigate = useNavigate()

    const { listServices, list, setBoxToDestroy, boxToDestroy, loading, totalRegisters } = useServicesList({
      ListProductsServiceUseCase
      
    })

    useEffect(() => {
      listServices(1)
    }, [])


    const columns = useMemo(() => {
        const createColumns: any[] = [
        
          {
            field: 'name',
            headerName: 'Código',
            flex: 1
          },
          
          {
            field: "actions",
            headerName: "Ações",
            headerAlign: "right",
            width: 100,
            renderCell: (params: any) => <ActionButtons params={params} setItemToDestroy={setBoxToDestroy} editLink={`/services-form/${params.row.id}`} />
          }
        ];
      
        return createColumns;
      }, []);
   

    return (
      <Can permissions={['menu:productsServices:manage']}>  
        <BaseScreen>
        {/* <ConfirmDialog title='Remover Caixa' onCancel={() => setBoxToDestroy('')} description='Você tem certeza?' open={!!boxToDestroy} onConfirm={handleDestroyBox}  />  */}
            <Paper >
              {loading && <Loader />}
                <BaseContentPage 
                    title='Serviços'
                    breadcrumb={[{ title: 'Serviços', link: "/services-list"}, { title: 'Listagem'}]}
                    Action={() => <Button LeftIcon={() => <GoPlus size={18} />} sx={{ width: '130px'}} boxLeftSx={{ gap: '10px', marginLeft: '5px'}} textSx={{ textTransform: 'Capitalize', fontWeight: 500}} onClick={() => navigate('/services-form')}>Adicionar</Button>}
                >
                  {!!list?.length ? <Table data={list} totalCount={totalRegisters} columns={columns} /> : <Placeholder description='Nenhum dado encontrado.' />}
                </BaseContentPage>
              
            </Paper>
                
        </BaseScreen>
        </Can>
    )
}

export { ServicesList };
